import React from "react";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";
import { withStyles } from "@material-ui/core/styles";

const StyledTextField = withStyles(() => ({
  root: {
    width: "130%",
    height: "2em",
    backgroundColor: "white",
    "& .MuiOutlinedInput-root": {
      "&:hover fieldset": {
        borderColor: "#4f2d7f",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#4f2d7f",
      },
    },
  },
}))(TextField);

const SearchInput = ({ value, onChange, placeholder = "Search", ...props }) => {
  return (
    <StyledTextField
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      variant="outlined"
      size="small"
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        ),
      }}
      {...props}
    />
  );
};

export default SearchInput;
